import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { clstagStr } from '@/utils/util';
type TabProp = {
  title: string | number;
  subTitle: string | number;
  onClick: AnyFunc;
  isActive: boolean;
  clstag: string;
  type?: number;
  tabId: string | number;
  icon?: string;
  readOnly?: boolean;
};
const TabButton = (props: TabProp) => {
  const { onClick, ...otherData } = props;
  const {
    title,
    subTitle,
    isActive,
    type = 1,
    icon,
    readOnly = false,
    clstag,
  } = otherData;
  let renderDOM = null;
  switch (type) {
    case 1:
      renderDOM = (
        <span
          className={classNames('tab-button-item', {
            isActive: isActive,
            readOnly: readOnly,
          })}
          onClick={() => {
            if (readOnly) {
              return;
            }
            onClick && onClick(otherData);
          }}
          clstag={clstagStr(clstag)}
        >
          <span className='font-JDZhengHT title'>{title}</span>
          <span className='font-JDZhengHT sub-title'>{subTitle}</span>
        </span>
      );
      break;
    case 2:
      renderDOM = (
        <span
          className={classNames(`tab-button-${type}`, {
            isActive: isActive,
            readOnly: readOnly,
          })}
          onClick={() => {
            if (readOnly) {
              return;
            }
            onClick && onClick(otherData);
          }}
          clstag={clstagStr(clstag)}
        >
          {title} ({subTitle})
        </span>
      );
      break;
    case 3:
      renderDOM = (
        <span
          className={classNames(`tab-button-${type}`, {
            isActive: isActive,
            readOnly: readOnly,
          })}
          onClick={() => {
            if (readOnly) {
              return;
            }
            onClick && onClick(otherData);
          }}
        >
          {icon && <img className='btn-icon' src={icon} />}
          <span className='font-JDZhengHT sub-title'>
            {title} ({subTitle})
          </span>
        </span>
      );
      break;
    default:
      return null;
  }
  return renderDOM;
};

export default React.memo(TabButton);
